const LocationPin = ({lat, lng, text}) => {
    return ( 
        <div>
            {text}
        </div>
     );
}
 
export default LocationPin;